import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import ShopPage from "./components/ShopPage";
import AuthPage from "./components/AuthPage";
import CheckoutPage from "./components/CheckoutPage";
import ThanksPage from "./components/ThanksPage";
import Header from "./components/Header";
import Footer from "./components/Footer";

const NotFound = () => (
  <>
    <Header />
    <main className="page container" id="main">
      <div className="state-box">
        <h1 style={{ margin: 0, fontSize: 28, color: "var(--text)" }}>Page not found</h1>
        <p>The page you’re looking for doesn’t exist.</p>
        <Link to="/" className="btn btn-primary">
          Back to the shop
        </Link>
      </div>
    </main>
    <Footer />
  </>
);

const App = () => (
  <>
    <a href="#main" className="skip-link">
      Skip to content
    </a>
    <Switch>
      <Route exact path="/" component={ShopPage} />
      <Route path="/login" render={() => <AuthPage mode="login" />} />
      <Route path="/register" render={() => <AuthPage mode="register" />} />
      <Route path="/checkout" component={CheckoutPage} />
      <Route path="/thanks" component={ThanksPage} />
      <Route component={NotFound} />
    </Switch>
  </>
);

export default App;
